import { MessageSquareQuote } from "lucide-react";
import type { FeatureModule } from "../registry";

export default {
  id: "replies",
  nav: [{ to: "/replies", label: "Saved replies", icon: MessageSquareQuote, group: "replies", order: 30 }],
  routes: [{ path: "/replies", lazy: async () => ({ Component: (await import("./RepliesPage")).RepliesPage }) }],
} satisfies FeatureModule;
